import API from './axios';

export const addOrganizationApiCall = async data => {
  return API.post('api/admin/organization', data);
};

export const getOrganizationsGroupsApiCall = async () => {
  return API.get('api/admin/organization-groups');
};

export const updateOrganizationsApiCall = async (msProvider, OrganizationID) => {
  return API.patch('api/admin/organization', msProvider, {
    params: {
      OrganizationID,
    },
  });
};

export const deleteOrganizationApiCall = async OrganizationID => {
  return API.delete('api/admin/organization', {
    params: {
      OrganizationID,
    },
  });
};

export const getPasswordPoliciesApiCall = async OrganizationID => {
  return API.get('api/admin/organization/password-policy', {
    params: {
      OrganizationID,
    },
  });
};

export const updatePasswordPoliciesApiCall = async (passwordPolicies, OrganizationID) => {
  return API.patch('api/admin/organization/password-policy', passwordPolicies, {
    params: {
      OrganizationID,
    },
  });
};

export const updateMaskFaultDetailsApiCall = async (MaskFaultDetails, OrganizationID) => {
  return API.patch('api/admin/organization/mask-fault-details', { MaskFaultDetails }, {
    params: {
      OrganizationID: OrganizationID.toString(),
    },
  });
};

/**
 * Get account lock settings for an organization.
 * Allowed: super_admin (any org), organization_admin (own org only).
 */
export const getAccountLockSettingsApiCall = async (OrganizationID) => {
  return API.get('api/admin/organization/account-lock-settings', {
    params: {
      OrganizationID: OrganizationID.toString(),
    },
  });
};

/**
 * Update account lock settings for an organization.
 * Allowed: super_admin (any org), organization_admin (own org only).
 */
export const updateAccountLockSettingsApiCall = async (OrganizationID, body) => {
  return API.patch('api/admin/organization/account-lock-settings', body, {
    params: {
      OrganizationID: OrganizationID.toString(),
    },
  });
};

/**
 * Read org MFA requirement (RequireMfaForUsers).
 * Allowed: super_admin (any org), organization_admin (own org only).
 */
export const getMfaSettingsApiCall = async OrganizationID => {
  return API.get('api/admin/organization/mfa-settings', {
    params: {
      OrganizationID: OrganizationID.toString(),
    },
  });
};

/**
 * Update org MFA requirement.
 * Allowed: super_admin (any org), organization_admin (own org only).
 */
export const updateMfaSettingsApiCall = async (OrganizationID, body) => {
  return API.patch('api/admin/organization/mfa-settings', body, {
    params: {
      OrganizationID: OrganizationID.toString(),
    },
  });
};
